export const ClientUpcomingEvents = {
  en: {
    'Upcoming events': 'Upcoming Events',
    'No upcoming events': 'No upcoming events',
    'Check back later for new sessions': 'Check back later for new sessions',
    'Loading events': 'Loading events...',
    'Select a time slot to book your session':
      'Select a time slot to book your session',
    'Available times': 'Available times',
    sessions_one: '{{count}} event',
    sessions_other: '{{count}} events',
    Today: 'Today',
    Tomorrow: 'Tomorrow',
    Hot: 'Hot',
    'Hurry up': 'Hurry up!',
    'Show less': 'Show less',
    'Show more sessions': '+{{count}} more',
    'Grid view': 'Grid view',
    'List view': 'List view',
    spotsLeft_one: '{{count}} spot left',
    spotsLeft_other: '{{count}} spots left',
  },
  uk: {
    'Upcoming events': 'Найближчі події',
    'No upcoming events': 'Немає найближчих подій',
    'Check back later for new sessions':
      "Перевірте пізніше, можливо з'являться нові сеанси",
    'Loading events': 'Завантаження подій...',
    'Select a time slot to book your session':
      'Оберіть час для бронювання сеансу',
    'Available times': 'Доступний час',
    sessions_one: '{{count}} подія',
    sessions_few: '{{count}} події',
    sessions_many: '{{count}} подій',
    Today: 'Сьогодні',
    Tomorrow: 'Завтра',
    Hot: 'Гаряче',
    'Hurry up': 'Поспішай!',
    'Show less': 'Згорнути',
    'Show more sessions': 'Ще +{{count}}',
    'Grid view': 'Сіткою',
    'List view': 'Списком',
    spotsLeft_one: 'залишилось {{count}} місце',
    spotsLeft_few: 'залишилось {{count}} місця',
    spotsLeft_many: 'залишилось {{count}} місць',
  },
};

export const ClientBookingEventsPage = ClientUpcomingEvents;
